module.exports = __webpack_public_path__ + "media/images/ivan-ed8450906b49705ad54d6896c4c769bb.png";